<template>
  <div
      v-if="newOrder"
      id="newOrder"
      aria-hidden="true"
      aria-labelledby="addOrdersModal"
      class="modal fade"
      data-backdrop="false"
      role="dialog"
      tabindex="-1"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 id="addOrdersModal" class="modal-title" style="margin-right: auto">Add New Order</h5>

          <div style="margin-left: auto; cursor: pointer" v-show="attachmentMode" @click="attachmentMode = false">
            <i class="fas fa-arrow-left" style="margin-right: 5px"></i>
          </div>
          <div style="cursor: pointer" @click="toggleAttachmentMode()">
            <span><button class="btn btn-sm btn-success">Add Attachment</button></span>
          </div>

          <button aria-label="Close" class="close" data-dismiss="modal" style="margin-left: 30px" type="button">
             <span aria-hidden="true" @click="cancelAddOrder()">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div v-show="!attachmentMode">
            <form-component :save-order="save" :data="inputs" @order_saved="orderSaved()" :files-ids="filesIds"></form-component>
          </div>
          <div v-show="attachmentMode">
            <UploadFileInput :editMode="false" :entity-type="'5'" @filesIds="setFilesIds"></UploadFileInput>
          </div>
        </div>
        <div class="modal-footer" style="border-top: none">
          <button
              v-if="newOrder"
              class="btn btn-sm cancel-add-order-button"
              @click="cancelAddOrder()"
          >
            CANCEL
          </button>
          <button
              @click="saveOrder()"
              class="btn btn-sm save-add-order-button"
          >
            SAVE
          </button>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
import apiClientCreator from "../../../../../helpers/api/request";
import FormComponent from "../Form/Form.component"
import UploadFileInput from "../../../contacts/components/AddContactForm/UploadFileInput.component";
export default {
name: "AddNewOrder.component",
  props:{
    newOrder: {
      type: Boolean,
      default: false
    }
  },
  components: {
    UploadFileInput,
    FormComponent
  },

  mounted(){
    // apiClientCreator("projects/orders/fetch_orders_form").get("").then(res => {
    //   this.inputs = res.data
    // });
  },

  data(){
  return {
    attachmentMode: false,
    save: false,
    inputs: [],
    filesIds: []
  }
  },
  methods: {
    setFilesIds(data){
      // console.log(data)
      this.filesIds = data
      // console.log(this.filesIds)
    },
    saveOrder(){
      this.save = true
    },
    toggleAttachmentMode(){
      this.attachmentMode = true
    },
    cancelAddOrder(){
      this.attachmentMode = false
      this.$emit('cancelAddNewOrder')
    },
    orderSaved(){
      this.save = false
      this.$emit('fetchNewOrdersList')
    }
  }
}
</script>

<style scoped>

.cancel-add-order-button{
  padding: 0.3rem;
  background-color: #100f11;
  color: white;
  font-size: 11px
}
.save-add-order-button{
  padding: 0.3rem;
  background-color: #2ea591;
  color: white;
  font-size: 11px
}
.modal-header{
  display: flex;
  padding: 5px 15px;
}

.form-control {
  border: 1px none #333;
  border-bottom-style: solid;
  display: block;
  width: 100%;
  height: 32px;
  padding: 0;
  margin-bottom: 15px;
  -webkit-box-shadow: none;
  -moz-box-shadow: none;
  box-shadow: none;
  border-radius: 0;
}

.btn-sm, .btn-group-sm > .btn {
  padding: 3px;
  font-size: 10px;
  line-height: 1.5;
  border-radius: 3px;
}
@media (min-width: 768px) {
  .modal-dialog {
    width: 865px;
    margin: 30px auto;
  }
  .modal-content{
    width: 800px;
  }
}

@media (max-width: 767px) {
  .modal-dialog {
    width: 400px;
    margin: 15px auto;
  }
  .modal-content{
    width: 400px;
    margin: 5px;
  }
}
</style>